<template>
  <div id="players-list-table">
    <v-data-table
      :headers="tableHeaders"
      :items="players"
      hide-default-footer
      disable-pagination
      sort-by="last_name"
      dense
    >
      <!--<editor-fold desc="ITEM SLOT">-->
      <template
        v-slot:item="{ item }"
      >
        <players-list-table-row
          v-if="!loading"
          :player="item"
          :max-values="maxValues"
          @click="onTableRowClick"
        />
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="PROGRESS SLOT">-->
      <template
        v-if="loading"
        v-slot:body
      >
        <tbody>
          <tr
            v-for="i in 25"
            :key="i"
          >
            <td>
              <v-skeleton-loader
                type="avatar"
                class="mr-3"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                width="60px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="60px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="60px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="20px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="20px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="20px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="80px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="20px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="20px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="60px"
              />
            </td>
            <td>
              <v-skeleton-loader
                type="text"
                max-width="60px"
              />
            </td>
            <td v-if="!isIndividualSport">
              <v-skeleton-loader
                type="text"
                max-width="60px"
              />
            </td>
          </tr>
        </tbody>
      </template>
      <!--</editor-fold>-->
    </v-data-table>
    <div
      v-if="pagination && pagination.last_page > 1"
      class="d-flex justify-center align-center py-5"
    >
      <pagination
        v-model="pagination.current_page"
        :last-page="pagination.last_page"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import PlayersListTableRow from '@/components/players/PlayersListTableRow.vue'

export default {
  name: 'PlayersListTable',
  components: { PlayersListTableRow, Pagination },
  props: {
    players: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    maxValues: {
      type: Object,
      required: true
    }
  },
  computed: {
    tableHeaders() {
      return [
        { sortable: false, class: 'pr-0' },
        { value: 'last_name', align: 'start', text: this.$t('table_headers.name') },
        ...(!this.isIndividualSport ? [{ value: 'player_position.name', text: this.$t('table_headers.player_overview.position') }] : []),
        { value: 'player_status.name', text: this.$t('table_headers.player_overview.status') },
        ...(this.hasItlModule ? [{ value: 'latest_stats.ACWR', text: this.$t('card_title.acwr') }] : []),
        ...(this.hasItlModule ? [{ value: 'latest_stats.DL', text: this.$t('table_headers.player_overview.dl') }] : []),
        ...(this.hasItlModule ? [{ value: 'latest_stats.DL_trend_3days', text: this.$t('table_headers.player_overview.dl_trend'), sortable: false }] : []),
        ...(this.hasItlModule && this.showWellnessData ? [{ value: 'latest_stats.MOO', text: this.$t('table_headers.main_load.mood') }] : []),
        ...(this.hasItlModule && this.showWellnessData ? [{ value: 'latest_stats.FAT', text: this.$t('table_headers.player_overview.fatigue') }] : []),
        ...(this.hasItlModule && this.showWellnessData ? [{ value: 'latest_stats.player_wellness', text: this.$t('table_headers.player_overview.shape') }] : []),
        ...(this.hasItlModule ? [{ sortable: false, text: this.$t('table_headers.player_overview.pain_report') }] : []),
        ...(this.hasItlModule ? [{ sortable: false, text: this.$t('table_headers.player_overview.sickness') }] : [])
      ]
    },
    name() {
      return this.data
    },
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    isIndividualSport() {
      return this.user.sport.is_individual
    },
    showWellnessData() {
      return !this.user.organisation_settings.has_short_wellness_feedback
    },
    hasItlModule() {
      return this.user.organisation_settings.has_itl_module || false
    }
  },
  methods: {
    onTableRowClick(playerId) {
      this.$emit('tableRowClick', playerId)
    }
  }
}
</script>
